export default {"src":"/_next/static/media/list-white.590aab10.svg","height":14,"width":18,"blurWidth":0,"blurHeight":0};